export const LOADING = "LOADING";
//user constant

// new
export const DASHBOARD = "DASHBOARD";

export const CITY_LIST = "CITY_LIST";
export const AREA_LIST = "AREA_LIST";
export const SLIDER_LIST = "SLIDER_LIST";
export const OCCASION_LIST = "OCCASION_LIST";
export const FUNCTION_LIST = "FUNCTION_LIST";
export const VENUES_LIST = "VENUES_LIST";
export const ESSENTIAL_LIST = "ESSENTIAL_LIST";
export const ESSENTIAL_TYPE_LIST = "ESSENTIAL_TYPE_LIST";
export const ORDER_LIST = "ORDER_LIST";
export const ORDER_DETAIL_LIST = "ORDER_DETAIL_LIST";
export const BOOKING_LIST = "BOOKING_LIST";
export const GALLERY_LIST = "GALLERY_LIST";
export const YOUTUBE_LIST = "YOUTUBE_LIST";
export const USER_LIST = "USER_LIST";
